var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTshirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.3,7.3C23.8,5.8,21.8,5,19.7,5h-0.2c-0.7,1.2-2,2-3.4,2s-2.8-0.8-3.4-2h-0.2c-2.1,0-4.2,0.8-5.7,2.3L3,11 l4,5l3-3v14h12V13l3,3l4-5L25.3,7.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -72,
    y: -648,
    className: "st3",
    width: 536,
    height: 680
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirt);
export default __webpack_public_path__ + "static/media/tshirt.73ab5205046dbf0b845d4b2666e54973.svg";
export { ForwardRef as ReactComponent };